<template>
    <div @click="$emit('input',id)" class="form__color" :class="['objective-color__background-color--'+id+' objective-color__after-border-color--'+id, {'form__color--active':value==id}]"></div>
</template>
<script>
    export default {
        name: 'color',
        props: ['id', 'value']
    }
</script>